import { ApolloError } from 'apollo-client'

// A lookup the server answered with "not found" (a mistyped story address, for example).
export const isNotFoundError = (error?: ApolloError): boolean =>
  !!error && !error.networkError && error.graphQLErrors.length > 0 && error.graphQLErrors.every(e => e.extensions?.code === 'NOT_FOUND')

// The connection or the server failed, so whether the record exists is unknown (CVL-138).
// The Apollo error link has already reported it to the error tracker.
export const isLoadFailure = (error?: ApolloError): boolean => !!error && !isNotFoundError(error)
